export const SUB_ACCOUNTS_API = '/api/dashboard/customer/subaccounts'
